module.exports = __webpack_public_path__ + "static/media/gesture_recognition_demo.1ce75d6d.png";